import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  alert: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  message: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: "0.15px",
  },
  outlinedWarning: {
    border: "1px solid rgba(255, 202, 58, 0.5)",
    color: "#665117",
    "& .MuiAlert-icon": {
      color: "#FFCA3A",
    },
  },
  outlinedInfo: {
    border: "1px solid rgba(64, 86, 199, 0.5)",
    color: "#1b234d",
    "& .MuiAlert-icon": {
      color: "#4056c7",
    },
  },
  outlinedError: {
    border: "1px solid rgba(218, 86, 36, 0.5)",
    color: "#663319",
    "& .MuiAlert-icon": {
      color: "#DA5624",
    },
  },
}));
